import {
  IconAirfare,
  type IconElement,
  IconHotel,
  IconLabour,
  IconMeals,
  IconMileage,
  IconReceipt,
  renderIcon,
} from '@procurify/ui'

import { ExpenseTypeLabelStyled } from './styles/ExpenseTypeLabelStyled'
import {
  ExpenseTypes,
  type ExpenseTypeEnum,
} from '../../entities/enums/ExpenseTypeEnum'
import { useFormatExpenseItemTypeLabel } from '../../hooks/useFormatExpenseItemTypeLabel'

const EXPENSE_TYPE_ICON_MAP: Record<ExpenseTypeEnum, IconElement> = {
  [ExpenseTypes.OTHER]: <IconReceipt />,
  [ExpenseTypes.MEALS]: <IconMeals />,
  [ExpenseTypes.MILEAGE]: <IconMileage />,
  [ExpenseTypes.LABOUR]: <IconLabour />,
  [ExpenseTypes.AIRFARE]: <IconAirfare />,
  [ExpenseTypes.LODGING]: <IconHotel />,
}

export interface IExpenseTypeLabelProps {
  type: ExpenseTypeEnum
}

export const ExpenseTypeLabel = ({ type }: IExpenseTypeLabelProps) => {
  const formatExpenseItemTypeLabel = useFormatExpenseItemTypeLabel()
  const icon = EXPENSE_TYPE_ICON_MAP[type]
  const label = formatExpenseItemTypeLabel(type)

  return (
    <ExpenseTypeLabelStyled>
      {renderIcon(icon, { size: 14, color: 'darkGrey' })}
      {label}
    </ExpenseTypeLabelStyled>
  )
}
